import { render, staticRenderFns } from "./selectDish.vue?vue&type=template&id=78b9cf5e&scoped=true&"
import script from "./selectDish.vue?vue&type=script&lang=js&"
export * from "./selectDish.vue?vue&type=script&lang=js&"
import style0 from "./selectDish.vue?vue&type=style&index=0&id=78b9cf5e&scoped=true&lang=css&"
import style1 from "./selectDish.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9cf5e",
  null
  
)

export default component.exports